import { useContext, useEffect, useRef } from "react";
import proj4 from "proj4";
import { useLeafletContext } from "@react-leaflet/core";
import { useMap } from "react-leaflet";
import parseGeoraster from "georaster";
import GeoRasterLayer from "georaster-layer-for-leaflet";
import { UrlContext } from "../partials/context/UrlContext";
import { LayerContext } from "../partials/context/LayerContext";
import { LoadingContext } from "../partials/context/Loading";
import { LayerAddContext } from "../partials/context/AddedLayer";
import { toast } from "react-toastify";

window.proj4 = proj4;

const GeotiffLayer = ({ url, options }) => {
  const {getPrevUrl}=useContext(UrlContext)
  const geoTiffLayerRef = useRef();
  const context = useLeafletContext();
  const { getLayer } = useContext(LayerContext);
  const { getLoading } = useContext(LoadingContext);
  const { getLayerAdd } = useContext(LayerAddContext);
  const map = useMap();
  // console.log(options);
  const notify = () => toast.error('Error in fetching the image.Try after sometime', {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme:"dark",
  });
  useEffect(() => {
    const container = context.layerContainer || context.map;
    // console.log(url);
    console.log("Is it coming to layer")
    fetch(url)
      .then((response) => response.arrayBuffer())
      .then((arrayBuffer) => {
        parseGeoraster(arrayBuffer).then((georaster) => {
          // console.log("georaster:", georaster);
          options.georaster = georaster;
          geoTiffLayerRef.current = new GeoRasterLayer(options);
          // console.log("add layer", geoTiffLayerRef.current);
          container.addLayer(geoTiffLayerRef.current);
          // console.log("after added layer");
          getLoading(false);
          getLayerAdd(true)
          // console.log(geoTiffLayerRef.current)
          // map.fitBounds(geoTiffLayerRef.current.getBounds());
        });
      })
      .catch((error) => {
        // console.log(error);
        getLoading(false);
        getLayerAdd(true);
        notify()
        // console.log(error);
      });
    
    return () => {
      // console.log(geoTiffLayerRef)
      if (geoTiffLayerRef.current) {
        // console.log("callign remove layer", geoTiffLayerRef.current);
        container.removeLayer(geoTiffLayerRef.current);
        getLoading(true);
        getLayerAdd(false);
      }
    }
  }, [url]);
  return null;
};
export default GeotiffLayer;
